import React from "react";
import "../../Components/Menu/Menu.css";
import Cookies from "../../Components/Cookies/Cookies";

export default function Privacy() {
  return (
    <div>
      <h3 className="title">Personvern</h3>
      <h4 className="sub-title">Hvorfor lagrer vi data om deg? </h4>
      <p className="content">
        For at du skal kunne bruke Bilista trenger vi enkelte opplysninger om
        deg. Ved å laste ned og ta i bruk denne appen godtar du at data som
        samles inn som følge av bruk i appen, lagres i appen og hos GMG – og at
        denne informasjonen brukes til dette:
        <ul>
          <li>
            Gjøre det enkelt å få oversikt over biler du eier eller leaser og
            informasjon om bilene.
          </li>
          <li>
            Lagre data om deg som brukes til å fylle inn skjemaer automatisk
            hvis du kjøper tjenester av tjenestetilbydere i appen.
          </li>
          <li>
            Lagre data om hvilke tjenester du benytter deg av i appen (som
            Flytpass) for å kunne tilby deg andre tjenester som kan være
            relevante for deg – for eksempel tekniske data om kjøretøyet og
            informasjon om bostedsadressen og lokasjonen din.
          </li>
        </ul>
        GMG bruker personopplysningene for å gjennomføre avtalen med deg.
      </p>
      <div className="cookies-privacy">
        <Cookies />
      </div>
    </div>
  );
}
